import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* sign3(action) {
  var payload = {
    action: "portal/sign",
    strategy: action.strategy,
    props: action.props,
    source: action.source,
  };
  yield put(serverRequest(payload));
}

export default sign3;
